export var ContentActionGroup;
(function (ContentActionGroup) {
    ContentActionGroup["AddTo"] = "AddTo";
    ContentActionGroup["Hero"] = "Hero";
    ContentActionGroup["MosApp"] = "MosApp";
    ContentActionGroup["None"] = "None";
    ContentActionGroup["Open"] = "Open";
    ContentActionGroup["OpenMenu"] = "OpenMenu";
    ContentActionGroup["OpenHero"] = "OpenHero";
    ContentActionGroup["Share"] = "Share";
    ContentActionGroup["Unknown"] = "Unknown";
})(ContentActionGroup || (ContentActionGroup = {}));
export var ContentActionItemType;
(function (ContentActionItemType) {
    ContentActionItemType[ContentActionItemType["Normal"] = 0] = "Normal";
    ContentActionItemType[ContentActionItemType["Divider"] = 1] = "Divider";
})(ContentActionItemType || (ContentActionItemType = {}));
//# sourceMappingURL=ContentAction.js.map